import { CSSTransition, TransitionGroup } from 'react-transition-group';
import ContactGroups from '../../Contact/ContactGroups/ContactGroups';
import Help from '../../Help/Help';
import NewRecent from '../../NewRecent/NewRecent';
import { DrawerComponents } from '../PageLayout';
import { NavList } from './NavList';
import SidebarDrawerHeader from './SidebarDrawerHeader';

interface Props {
    hasEntered: boolean;
    groupsList: number | null;
    drawerComponent: DrawerComponents | null;
}

export default function SidebarDrawer({ hasEntered, drawerComponent, groupsList }: Props) {
    return (
        <div className="sidebarDrawer">
            <div className="sidebarDrawer__header">
                <SidebarDrawerHeader drawerComponent={drawerComponent} />
            </div>
            {hasEntered && (
                <TransitionGroup component="div" className="sidebarDrawer__transitionWrapper">
                    <CSSTransition
                        key={!!drawerComponent ? drawerComponent : 'out'}
                        timeout={80}
                        mountOnEnter
                    >
                        <div className="sidebarDrawer__transition--fade">
                            {drawerComponent === 'new/Recent' && <NewRecent />}
                            {drawerComponent === 'groups' && (
                                <ContactGroups groupsList={groupsList} />
                            )}
                            {drawerComponent === 'help' && <Help />}
                            {(drawerComponent === 'settings' ||
                                drawerComponent === 'campaigns') && (
                                <NavList drawerComponent={drawerComponent} />
                            )}
                        </div>
                    </CSSTransition>
                </TransitionGroup>
            )}
        </div>
    );
}
